import React from 'react';

import AtlassianIntelligenceIcon from '@atlaskit/icon/core/atlassian-intelligence';
import type { NewCoreIconProps } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';

export const QuickSummaryIcon = (props: NewCoreIconProps) => (
	<AtlassianIntelligenceIcon color={token('color.icon')} {...props} />
);
